import { Validator, AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[uniqueAdditionalInsured]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: UniqueInterestValidatorDirective, multi: true }
    ]
})
export class UniqueInterestValidatorDirective implements Validator {
    @Input("addressControlPrefix") addressControlPrefix: string;

    validate(control: AbstractControl): ValidationErrors | null {
        if (!control.value || typeof control.value !== 'object') {
            return null;
        }

        let seenEntries = new Set<string>();
        let count: number = Object.keys(control.value).filter(key => key.startsWith(`${this.addressControlPrefix}StreetAddress_`)).length;

        //We need to ensure duplicate only for Insured name and Interest type only 
        for (let i = 0; i < count; i++) {
            let insuredNameAndInterestType: string = `${control.value[`${this.addressControlPrefix}InterestType_${i}`]?.trim()?.toLowerCase() || ''}|` +
                `${control.value[`${this.addressControlPrefix}Name_${i}`]?.trim()?.toLowerCase() || ''}|`;

            if (seenEntries.has(insuredNameAndInterestType)) {
                return {
                    'duplicateInterests': true,
                    'duplicateInterestsMsg': 'Additional Insured/Loss Payee cannot have identical values.'
                }
            } else {
                seenEntries.add(insuredNameAndInterestType);
            }
        }
        return null;
    }
}